import { render } from "./InlineActionDropdown.vue?vue&type=template&id=ab4ab296"
import script from "./InlineActionDropdown.vue?vue&type=script&lang=js"
export * from "./InlineActionDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"InlineActionDropdown.vue"]])

export default __exports__